<template>
  <v-toolbar
    id="core-toolbar"
    app
    flat
    prominent>
    <v-toolbar-title class="font-weight-bold text-general">
      <v-btn
        v-if="responsive"
        class="default v-btn--simple"
        icon
        @click.stop="onClickBtn"
      >
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      <v-btn
        class="toolbar-items mr-4"
        color="#323D77"
        href="https://dashboard.platform.heron.gr/d/_RGuHhSMz/heron-admin?orgId=1&refresh=1m"
        target="_blank"
      >
        Dashboard
      </v-btn>
      <v-btn
        class="toolbar-items mr-4"
        color="green"
        @click="registerUser">
        Register end user
      </v-btn>
      <v-btn
        class="toolbar-items mr-4"
        color="heron_info"
        @click="registerProjectUser"
      >
        Register project user
      </v-btn>
    </v-toolbar-title>
    <v-spacer />
    <!-- <v-flex align-center layout py-2> -->
    <v-btn
      class="toolbar-items"
      color="#e80e0e"
      @click="logout">
      Log Out
      <v-icon right>
        mdi-power
      </v-icon>
    </v-btn>
    <!-- </v-flex> -->
    <!-- <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-btn class="toolbar-items" color="#e80e0e" @click="logout">
          Log Out
          <v-icon right>
            mdi-power
          </v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar-items> -->
  </v-toolbar>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data: () => ({
    notifications: [
      'Mike, Thanos is coming',
      '5 new avengers joined the team',
      "You're now friends with Capt",
      'Another Notification',
      'Another One - Dj Khalid voice'
    ],
    register_user: 'Register user',
    register_project_user: 'Register project user',
    responsive: false,
    responsiveInput: false,
    links: [
      {
        name: 'Dashboard',
        Link:
          'https://dashboard.platform.heron.gr/d/_RGuHhSMz/heron-admin?orgId=1&refresh=1m'
      }
    ]
  }),

  computed: {
    ...mapGetters(['authorized'])
  },

  // watch: {
  //   $route(val) {
  //     this.title = val.meta.name;
  //   },
  // },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/')
      })
    },
    registerUser: function () {
      // this.$router.push("/register_user");
      let routeData = this.$router.resolve({ name: 'register_user' })
      window.open(routeData.href, '_blank')
    },
    registerProjectUser: function () {
      // this.$router.push("/register_project_user");
      let routeData = this.$router.resolve({ name: 'register_project_user' })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
